export interface IFitCCDropDown 
{
    value: string;
    text: string;
    dependencyField?: string;
    setOtherField?: string;
}